<template>
  <div class="cart-subscription-item">
    <el-row :gutter="16">
      <el-col :span="12">
        <img :src="data.image" class="product__image" />
      </el-col>
      <el-col :span="12">
        <div class="cart-subscription-item__content">
          <h3 class="cart-subscription-item__title">
            <text-ellipsis :rows="2">{{ data.product_name }}</text-ellipsis>
          </h3>
          <p class="text-xs" v-show="data.sku_item_parent_name_1">
            {{ data.sku_item_parent_name_1 }} : {{ data.sku_set_item_name1 }}
          </p>
          <p class="text-xs" v-show="data.sku_item_parent_name_2">
            {{ data.sku_item_parent_name_2 }} : {{ data.sku_set_item_name2 }}
          </p>
          <p class="text-xs">{{ $t('ec-line014.cart.quantity', { value: data.quantity }) }}</p>
          <p class="text-base text-black font-bold">
            {{ $t('cartList.item.priceWithTax', { price: $n(data.price, 'currency', 'ja-JP') }) }}
          </p>
        </div>
        <div class="cart-subscription-item__action">
          <el-button size="mini" @click="addToCarts">{{ $t('ec-line014.cart.rePurchaseBtn') }}</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import TextEllipsis from '@/components/TextEllipsis.vue'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { TextEllipsis },
  methods: {
    addToCarts() {
      // todo
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/cart-subscription-item.scss';
</style>
